import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Link, useNavigate } from "react-router-dom";
import { RootMenu } from "../config/RootMenu";
import { ClientMenu } from "../config/ClientMenu";
import { BreadCrumb, RouteComponentProps } from "../models/RouteComponent";
import { UserTypes } from "../enum/UserTypes";
import { ConsultantMenu } from "../config/ConsultantMenu";
import { setUserDetails, saveActiveClient, saveActiveSite, saveActiveType } from "../service/session-service";
import { UserSession } from "../models/UserSession";
import { SideMenu, childSideMenu } from "../models/SideMenu";
import { Breadcrumbs, ListItemButton } from "@mui/joy";
import { useEffect, useState } from "react";
import { Avatar } from "primereact/avatar";

export default function BreadCrumbsComponent(props: RouteComponentProps) {
  const [activeBreadcrumbs, setActiveBreadcrumbs] = useState([] as any[]);
  const session = props.session || {};
  const navigate = useNavigate();

  const loadBreadcrumbs = () => {
    setActiveBreadcrumbs(props.breadcrumbs);
  };

  const navigatePage = (breadcrumb?: BreadCrumb, index?: number) => {
    if (!breadcrumb || !index) {
      navigateBack();
      props.setBreadcrumbs([]);
      return;
    }
    if (!index) index = 0;
    if (breadcrumb?.userType == UserTypes.DSF) {
      let setObject: UserSession = { active_type: UserTypes.DSF } as any;
      setObject.client_id = undefined;
      setObject.consultant_id = undefined;
      setObject.site_id = undefined;
      props.setSession({ ...props.session, ...setObject });
      setUserDetails(props.session);
      // Save to localStorage
      saveActiveClient(undefined, undefined);
      saveActiveSite(undefined, undefined);
      saveActiveType(UserTypes.DSF);
    }
    if (breadcrumb?.userType == UserTypes.Consultant) {
      let setObject: UserSession = { active_type: UserTypes.Consultant } as any;
      setObject.client_id = undefined;
      setObject.site_id = undefined;
      props.setSession({ ...props.session, ...setObject });
      setUserDetails(props.session);
      // Save to localStorage
      saveActiveClient(undefined, undefined);
      saveActiveSite(undefined, undefined);
      saveActiveType(UserTypes.Consultant);
    }
    if (breadcrumb?.userType == UserTypes.Client) {
      let setObject: UserSession = { active_type: UserTypes.Admin } as any;
      setObject.site_id = undefined;
      props.setSession({ ...props.session, ...setObject });
      setUserDetails(props.session);
      // Save to localStorage - keep client, clear site
      saveActiveSite(undefined, undefined);
      saveActiveType(UserTypes.Admin);
    }
    let length = activeBreadcrumbs?.length || 0;
    console.log("breadcrumb == ", breadcrumb);
    if (breadcrumb.isLabel) {
      length = length + 1;
    }
    console.log("length == ", length);
    activeBreadcrumbs.splice(index + (breadcrumb.isLabel ? 0 : 1), length);
    props.setBreadcrumbs(activeBreadcrumbs);
    navigate(breadcrumb.link);
  };

  const navigateBack = () => {
    let setObject: UserSession = { active_type: props.session.user_type } as any;
    switch (props.session.user_type) {
      case UserTypes.DSF:
        setObject.client_id = undefined;
        setObject.consultant_id = undefined;
        setObject.site_id = undefined;
        setObject.client_name = undefined;
        setObject.client_logo = undefined;
        // Save to localStorage
        saveActiveClient(undefined, undefined);
        saveActiveSite(undefined, undefined);
        saveActiveType(UserTypes.DSF);
        navigate("/admin-dashboard");
        break;
      case UserTypes.Admin:
      case UserTypes.Employee:
        setObject.site_id = undefined;
        // Save to localStorage - keep client, clear site
        saveActiveSite(undefined, undefined);
        saveActiveType(props.session.user_type);
        navigate("/client-dashboard");
        break;
      case UserTypes.Consultant:
        setObject.site_id = undefined;
        setObject.client_id = undefined;
        setObject.client_name = undefined;
        setObject.client_logo = undefined;
        // Save to localStorage
        saveActiveClient(undefined, undefined);
        saveActiveSite(undefined, undefined);
        saveActiveType(UserTypes.Consultant);
        navigate("/consultant-dashboard");
        break;
      default:
        setObject.site_id = undefined;
        setObject.site_name = undefined;
        // Save to localStorage
        saveActiveSite(undefined, undefined);
        saveActiveType(props.session.user_type);
        navigate("/admin-dashboard");
        break;
    }
    props.setSession({ ...props.session, ...setObject });
    setUserDetails(props.session);
  };

  useEffect(() => {
    loadBreadcrumbs();
  }, [props.breadcrumbs]);

  return (
    <>
      <Breadcrumbs
        size="sm"
        aria-label="breadcrumbs"
        separator={<ChevronRightRoundedIcon fontSize="small" />}
        sx={{ pl: 0 }}
      >
        <ListItemButton
          onClick={event => {
            navigatePage();
          }}
        >
          <HomeRoundedIcon />
        </ListItemButton>
        {activeBreadcrumbs
          .filter(e => !!e.label)
          .map((breadcrumb, index) => {
            return (
              <ListItemButton
                key={`breadcrumb-${index}`}
                onClick={event => {
                  navigatePage(breadcrumb, index);
                }}
              >
                {breadcrumb.label}
              </ListItemButton>
            );
          })}
      </Breadcrumbs>

      {session.client_name && session.client_logo && (
        <div
          className="flex-auto"
          style={{ display: "flex", alignItems: "center", gap: "1rem", justifyContent: "flex-end" }}
        >
          <label>{session.client_name}</label>
          <Avatar className="p-overlay-badge" image={session.client_logo} size="xlarge" />
        </div>
      )}
    </>
  );
}
